






















































































































































































































import Vue from 'vue'
import { sortBy, cloneDeep, debounce, clamp, pickBy } from 'lodash'
import LeftSidebarLayout from '@/components/LeftSidebarLayout'
import EventListItem from '@/components/EventListItem'
import TabDisplay from '@/components/TabDisplay'
import CreateEditCast from '@/components/CreateEditCast'
import ClipLoader from '@/components/vue-spinner/ClipLoader.vue'
import SelfTest from '@/components/SelfTest'
import Modal from '@/components/Modal'
import KisweNotification from '@/components/Kiswe/KisweNotification'
import KisweStudioLogo from '@/components/Kiswe/KisweStudioLogo'
import VideoObject, { VideoObjectConfig } from '../../classes/VideoObject'
import { Button, Input, Popover } from 'element-ui'
import helpers from '@/helpers'
import releaseNotes from '@/ReleaseNotes'
import { Cast } from '@/types/casts'
import { CloudCastEvent, EventSheduleType } from '@/types/events'
import { KeyDict } from '@/types'
import { Stream } from '@/types/streams'
import { CastProperty } from '@/types/admin'
import { UserProfile } from '@/types/users'
import { AssetGroup } from '@/types/assets'
import { ReleaseNotes } from '@/types/releasenotes'
import { CastTemplate } from '@/types/casttemplates'
import { AbilityAction, AbilitySubject } from '@/abilitiesByRole'
import Timeout = NodeJS.Timeout
import { isMobile } from 'mobile-device-detect'
import { DatePicker } from 'element-ui'
import '@/styles/components/forms.scss'
import clock from '@/classes/Clock'
import { versionToInt } from '@/classes/versions'
import { Feature } from '@/featureFlags/featureFlags'
import CreateEventButton from './CreateEventButton.vue'

const COPY_CAST_SUFFIX = '[COPY]'

export default Vue.extend({
  name: 'EventList',
  computed: {
    showSelfTestButton (): boolean {
      return this.userProfile?.selftest === undefined && !this.userProfile?.anonymous
    },
    canReadEvents (): boolean {
      return this.$can(AbilityAction.Read, AbilitySubject.Event) || this.$can(AbilityAction.Cast, AbilitySubject.Cast)
    },
    isSelfServe (): boolean {
      return this.$hasFeature(Feature.SELF_SERVE)
    },
    isMobile (): boolean {
      return isMobile
    },
    archivingNote (): string {
      let note = 'Note: Event archives and created clips are available from the Clipper interface for maximum '
      note += this.isSelfServe ? '2 calendar weeks.' : '3 calendar months.'
      return note
    },
    canCreateCast (): boolean {
      if (this.currentFilter === EventSheduleType.Completed) return false
      if (!this.$can(AbilityAction.Create, AbilitySubject.Cast)) return false
      if (!this.$can(AbilityAction.Create, AbilitySubject.Event)) return false
      return true
    },
    onceAMinute (): number{
      // everything that uses this will be re-evaluated about once a minute.
      // the value itself is not relevant
      return this.$store.direct.state.clock.minute * 0.1
    },
    events (): CloudCastEvent[] {
      const input = this.$store.direct.state.events.events
      const once = this.onceAMinute
      const result : CloudCastEvent [] = []
      if (once < 0) {}
      const now = clock.nowInSeconds()
      for (const event of input){
        const endDateSeconds = event.end_date.seconds
        if (endDateSeconds > now){
          result.push(event)
        }
      }
      return input
    },
    completedEvents (): CloudCastEvent[] {
      const input = this.$store.direct.state.events.completedEvents
      const once = this.onceAMinute
      const result : CloudCastEvent [] = []
      const inResult = new Set()
      if (once < 0){}
      const now = clock.nowInSeconds()
      for(const event of input){
        const endDateSeconds = event.end_date.seconds
        if (endDateSeconds <= now) {
          result.push(event)
          inResult.add(event.id)
        }
      }
      for(const event of this.events){
        const endDateSeconds = event.end_date.seconds
        if (endDateSeconds <= now) {
          if(!inResult.has(event.id)){
            result.push(event)
            input.push(event)
          }
        }
      }
      return result
    },
    currentUserId (): string {
      return this.$store.direct.state.user.id
    },
    eventsLoaded (): boolean {
      return this.$store.direct.state.events.eventsLoaded
    },
    completedEventsLoaded (): boolean {
      return this.$store.direct.state.events.completedEventsLoaded
    },
    activeTeam (): string {
      return this.$store.direct.state.team.activeTeam
    },
    streams (): KeyDict<Stream> {
      return this.$store.direct.state.team.streams
    },
    castProperties (): KeyDict<CastProperty> {
      return this.$store.direct.state.team.castProperties
    },
    userProfile (): UserProfile | null {
      return this.$store.direct.state.user.profile
    },
    currentTeam (): UserProfile[] {
      return this.$store.direct.state.team.currentTeam
    },
    teamStreams (): KeyDict<Stream> {
      return this.$store.direct.state.team.streams
    },
    customStreams (): KeyDict<Stream> {
      return this.$store.direct.state.events.customStreams
    },
    castTemplates (): CastTemplate[] {
      return this.$store.direct.state.castTemplates.templates
    },
    folderList (): AssetGroup[] {
      return Object.values(this.$store.direct.state.assets.folderList).filter(folder => !folder.parent_id)
    },
    currentVersion (): string {
      return releaseNotes().currentVersion
    },
    currentFeatures (): (string|string[])[] {
      const release = releaseNotes().releases[this.currentVersion]
      return (release.features !== undefined) ? release.features : []
    },
    supportLink (): string {
      const release = releaseNotes().releases[this.currentVersion]
      return release.supportLink ?? 'https://support.kiswe.com'
    },
    pagedCompletedEvents (): CloudCastEvent[] {
      const start = this.page * this.numEventsPerPage
      const end = Math.min(start + this.numEventsPerPage, this.filteredEvents.length)
      return this.filteredEvents.slice(start, end)
    },
    numPages (): number {
      let total = this.filteredEvents.length
      total /= this.numEventsPerPage
      return Math.ceil(total)
    },
    showPageButtons (): number[] {
      const array: number[] = []
      for (let index = Math.max(0, this.page - 3); index < Math.min(this.numPages, this.page + 3); index++) {
        array.push(index)
      }
      return array
    },
    showLoadingEvents (): boolean {
      let status = false
      if (this.currentFilter === EventSheduleType.Active || this.currentFilter === EventSheduleType.Scheduled) {
        status = this.eventsLoaded === false
      } else if (this.currentFilter === EventSheduleType.Completed) {
        status = this.completedEventsLoaded === false
      }
      return status
    },
    showNoEvents (): boolean {
      let status = false
      if (this.currentFilter === EventSheduleType.Active || this.currentFilter === EventSheduleType.Scheduled) {
        status = this.eventsLoaded && this.filteredEvents.length === 0
      } else if (this.currentFilter === EventSheduleType.Completed && this.completedEventsLoaded) {
        status = this.filteredEvents.length === 0
      }
      return status
    },
    noCompletedEvents (): boolean {
      return this.currentFilter === EventSheduleType.Completed && this.completedEventsLoaded && this.completedEvents.length === 0
    },
    eventsForList (): CloudCastEvent[] {
      let events: CloudCastEvent[] = []
      if (this.currentFilter === EventSheduleType.Completed) {
        events = this.pagedCompletedEvents
      } else {
        events = this.filteredEvents
      }
      return events
    },
    filteredEvents (): CloudCastEvent[] {
      let events: CloudCastEvent[] = []
      const seconds = Math.floor(new Date().getTime() / 1000)
      if (this.currentFilter === EventSheduleType.Active) {
        events = this.events.filter((event: any) => seconds > (event.start_date.seconds - 60) && seconds < event.end_date.seconds)
        events = sortBy(events, 'start_date.seconds')
      } else if (this.currentFilter === EventSheduleType.Scheduled) {
        events = this.events.filter(event => seconds < event.start_date.seconds)
        events = sortBy(events, 'start_date.seconds')
      } else if (this.currentFilter === EventSheduleType.Completed) {
        events = sortBy(this.completedEvents, 'end_date.seconds').reverse()
        events = events.filter((event: CloudCastEvent) => {
          const startDate = this.dateRange[0].getTime() / 1000
          const endDate = this.dateRange[1].getTime() / 1000
          if (event.start_date.seconds < startDate) return false
          if (event.end_date.seconds > endDate) return false
          return this.searchQueryDebounced.toLowerCase().trim().split(' ').some((search) => {
            if (event.name?.toLowerCase().includes(search)) return true
            return false
          })
        })
      }
      return events
    },
  },
  watch: {
    activeTeam () {
      this.loadData()
    },
    userProfile () {
      this.checkVersionNumber()
      this.rejectAnonymousUser()
    }
  },
  data: () => ({
    audioContext: {} as AudioContext,
    releaseNotes: {} as ReleaseNotes,
    showCastModal: false,
    showIntro: false,
    selectedCast: {},
    eventForCast: null as CloudCastEvent | null,
    eventToAddCastTo: '',
    currentFilter: EventSheduleType.Active,
    castAudioActive: '',
    castsPerEvent: {},
    streamsManager: {},
    videoObjects: [] as VideoObject[],
    audioActivated: false,
    updateInterval: null as Timeout | null,
    showVersionUpdate: false,
    page: 0,
    runSelfTest: false,
    firstpage: '<<',
    endpage: '>>',
    popupselftestVisible: false,
    searchQuery: '',
    searchQueryDebounced: '',
    numEventsPerPage: 15,
    updateList: 0, // adjust every time you want to trigger the eventlist update
    mobileWarningVisible: false, // only if isMobile
    tabs: [
      { label: 'Active', value: EventSheduleType.Active, icon: '' },
      { label: 'Scheduled', value: EventSheduleType.Scheduled, icon: '' },
      { label: 'Completed', value: EventSheduleType.Completed, icon: '' }
    ],
    dateRange: [
      new Date(Date.now() - 3600 * 1000 * 24 * 365),  // last year
      new Date()
    ]
  }),
  created () {
    if (this.activeTeam !== '') {
      this.loadData()
    }
    this.audioContext = new AudioContext()
    document.querySelector('body')?.addEventListener('click', () => {
      this.audioContext.resume().then(() => {
        this.audioActivated = true
      }).catch(error => {
        console.error('EventList Create Error', error)
      })
    })
    const data = {
      cc_cast: 'None',
      cc_event: 'None'
    }
    this.$store.direct.dispatch.logs.updateClientInfo(data)
    setTimeout(() => {
      if (this.userProfile !== null) {
        if (this.userProfile.selftestshown === undefined) {
          this.popupselftestVisible = true
          this.$store.direct.dispatch.user.updateProfile({ id: this.currentUserId, selftestshown: true })
        }
      }
    }, 2000)
    this.checkVersionNumber()
    this.rejectAnonymousUser()
  },
  mounted () {
    if (isMobile) this.mobileWarningVisible = true
  },
  beforeDestroy () {
    for (let i = 0; i < this.videoObjects.length; i++) {
      this.videoObjects[i].stopPlay()
    }
    this.videoObjects.splice(0)
    if (this.updateInterval) {
      clearInterval(this.updateInterval)
    }
    this.$store.direct.dispatch.events.unsubscribeEvents()
  },
  methods: {
    initSelfTest (): void {
      if (isMobile) {
        const route = this.$router.resolve({ name: 'selftest' })
        window.location.href = route.href
        return
      }

      this.runSelfTest = true
    },
    checkVersionNumber (): void {
      if (this.userProfile === null || this.userProfile.version === undefined) {
        return
      }
      if (versionToInt(this.userProfile.version) < versionToInt(this.currentVersion)) {
        this.$store.direct.dispatch.user.updateProfile({ id: this.currentUserId, version: this.currentVersion })
        this.showVersionUpdate = true
      }
    },
    rejectAnonymousUser () {
      if (!!this.userProfile?.anonymous) this.$router.push({ name: 'end-session' })
    },
    async deleteEvent (event) {
      await this.$store.direct.dispatch.events.deleteEvent(event)
    },
    async stopEvent (event) {
      await this.$store.direct.dispatch.events.stopEvent(event)
    },
    loadData () {
      this.$store.direct.dispatch.events.clearEvents()
      // TODO needs unsubscribe ?
      // this.$store.direct.dispatch.assets.subscribeTeamAssetGroup(this.activeTeam)
      setTimeout(() => {
        this.$store.direct.dispatch.events.subscribeEvents(this.activeTeam).then(() => {
          this.$store.direct.dispatch.events.subscribeCompletedEvent(this.activeTeam)
        }).catch(error => console.log(error))
        if (this.updateInterval) {
          clearInterval(this.updateInterval)
        }
      }, 300)
    },
    createEvent () {
      if (this.isSelfServe) {
        this.$router.push({ name: 'createEvent' })
      } else {
        this.showCreateCastModal()
      }
    },
    createCast (cast) {
      this.$store.direct.dispatch.logs.addLog({ message: 'Create Event button clicked', level: 'info' })
      this.$store.direct.dispatch.events.createCast(cast).then(() => {
        this.$message({ type: 'success', message: 'New Event created' })
        this.updateList += 1
        this.closeCastModal()
        this.$store.direct.dispatch.logs.addLog({ message: 'Create Event succeeded', level: 'info' })
      }).catch(error => {
        console.error('createCast Error', error)
      })
    },
    createCastFromCopy (castCopy) {
      this.$store.direct.dispatch.logs.addLog({ message: 'Copy Event button clicked', level: 'info' })
      this.$store.direct.dispatch.events.copyCast(castCopy).then(() => {
        this.$message({ type: 'success', message: 'Copy of Event created' })
        this.updateList += 1
        this.closeCastModal()
        this.$store.dispatch('logs/addLog', { message: 'Copy Event succeeded', level: 'info' })
      }).catch(error => {
        console.error('copyCast Error', error)
      })
    },
    castLoaded () {
      if (this.userProfile) {
        // de-activate for next visit
        if (this.userProfile.introshown === undefined || this.userProfile.introshown === false) {
          this.showIntro = true
          this.$store.direct.dispatch.user.updateProfile({
            id: this.currentUserId,
            introshown: true
          } as Partial<UserProfile>)
        }
      }
    },
    copyOutputs (castCopy) {
      // create new cast with basic properties copied:
      this.$store.direct.dispatch.events.copyCastOutputs(castCopy).then(() => {
        this.$message({ type: 'success', message: 'Cast outputs copied' })
      }).catch(error => {
        console.error('Cast output copy Error', error)
      })
    },
    updateCast (cast) {
      this.$store.direct.dispatch.logs.addLog({ message: 'Update Event button clicked', level: 'info' })
      this.$store.direct.dispatch.events.updateCast(cast).then(() => {
        this.$message({ type: 'success', message: 'Event has been updated' })
        this.closeCastModal()
        this.$store.direct.dispatch.logs.addLog({ message: 'Update Event succeeded', level: 'info' })
      }).catch(error => {
        console.error('updateCast Error', error)
      })
    },
    editCast (cast) {
      if (this.isSelfServe) this.$router.push({ name: 'editEvent', params: { id: cast.id } })
      this.selectedCast = cast
      this.eventForCast = this.events.find(e => e.id === cast.event_id) ?? null
      if (this.eventForCast === null) {
        this.$store.direct.dispatch.logs.addLog({
          message: 'Edit Event button clicked. But no associated event could be found',
          cast: cast.id,
          level: 'error'
        })
        this.$message.error('Failed to edit invalid event')
        return
      }
      this.showCastModal = true
      this.$store.direct.dispatch.logs.addLog({
        message: 'Edit Event button clicked.',
        cast: cast.id,
        level: 'info'
      })
    },
    addOutputVideo (vid) {
      if (!this.streamsManager.hasOwnProperty(vid.video)) {
        Vue.set(this.streamsManager, vid.video, {})
        this.makeVideoObject(vid.video, vid.variant)
      }
    },
    makeVideoObject (id, variant) {
      const vidObject = new VideoObject({
        id: id,
        streamToPlay: variant,
        udpEnabled: this.userProfile && this.userProfile.udpEnabled !== undefined ? this.userProfile.udpEnabled : false,
        callback: stream => {
          Vue.set(this.streamsManager, id, stream)
        },
        killStream: stream => {
          try {
            this.streamsManager[stream.id].stopPlay()
          } catch (e) {}
          this.$delete(this.streamsManager, stream.id)
        },
        restartStream: stream => {
          console.log('restartStream', stream)
        }
      } as VideoObjectConfig)
      this.videoObjects.push(vidObject)
    },
    tabChanged (tab: EventSheduleType) {
      if (tab === EventSheduleType.Completed) {
        this.dateRange[0] = new Date(Date.now() - 3600 * 1000 * 24 * 365)  // last year
        this.dateRange[1] = new Date()
        this.$store.direct.dispatch.events.updateSubscriptionCompletedEvent(this.activeTeam)
      }
      this.currentFilter = tab
      this.page = 0
      this.$store.direct.dispatch.logs.addLog({
        message: 'Event filter tab clicked',
        data: {
          event_tab: tab
        },
        level: 'info'
      })
    },
    showCopyCastModal (sourceCast) {
      // copy minimal properties
      let copyCast = new Cast() // was {}
      copyCast = {
        ...copyCast,
        copying: true,
        name: sourceCast.name + ' ' + COPY_CAST_SUFFIX,
        originalCast: JSON.stringify(sourceCast),
        srt: sourceCast.srt,
        largemachine: sourceCast.largemachine === true ? true : false,
        record_isos: sourceCast.record_isos,

        // copy input_streams
        input_streams: sourceCast.input_streams,

        // copy quality settings
        region: sourceCast.region,
        quality: sourceCast.quality,
        presets: sourceCast.presets,
        framerate: sourceCast.framerate,
        gop_size: sourceCast.gop_size,

        // copy invited casters
        invited_casters: pickBy(sourceCast.invited_casters, (caster) => !caster.anonymous),

        // copy asset groups
        asset_groups: sourceCast.asset_groups,

        // copy scenes + content
        activeScene: sourceCast.activeScene,
        scenes: cloneDeep(sourceCast.scenes),

        // copy dates
        start_date: sourceCast.start_date,
        end_date: sourceCast.end_date
      }

      // remove reactivity from object
      // TODO: Can we use cloneDeep() here? Because the stringify removes the Date objects? Or does cloneDeep() keep the
      //       reactivity? If so recreate the Date objects here so we don't have to check for strings in CreateEditCast.
      this.selectedCast = JSON.parse(JSON.stringify(copyCast))
      this.eventForCast = null
      this.showCastModal = true
    },
    showCreateCastModal () {
      this.selectedCast = new Cast() // was {}
      this.eventForCast = null
      this.showCastModal = true
      this.$store.direct.dispatch.logs.addLog({ message: 'Create Event modal button clicked', level: 'info' })
    },
    setActiveAudio (paramCast: string) {
      this.castAudioActive = (this.castAudioActive !== paramCast) ? paramCast : ''
    },
    closeCastModal () {
      this.showCastModal = false
    },
    genRandom () {
      return helpers.makeId()
    },
    requestCasterRepublish (params: { caster: string, cast: string }) {
      this.$store.direct.dispatch.logs.addLog({
        message: `Request caster ${params.caster} to republish`,
        level: 'info'
      })
      const cast = { 'republishRequested': {}, 'id': params.cast }
      cast.republishRequested[params.caster] = true
      this.$store.direct.dispatch.events.requestCasterRepublish(cast).then(() => {
        this.$store.direct.dispatch.logs.addLog({ message: 'Update Event succeeded', level: 'info' })
      }).catch(error => {
        console.error('requestCasterRepublish Error', error)
      })
    },
    debounceSearchQuery: debounce(function (this: any, value: string): void {
      this.searchQueryDebounced = value
      this.page = clamp(this.page, 0, this.numPages - 1)
    }, 200)
  },
  components: {
    LeftSidebarLayout,
    EventListItem,
    TabDisplay,
    CreateEditCast,
    SelfTest,
    Modal,
    KisweNotification,
    CreateEventButton,
    KisweStudioLogo,
    'clip-loader': ClipLoader,
    'el-button': Button,
    'el-input': Input,
    'el-popover': Popover,
    'el-date-picker': DatePicker
  }
})
